module.exports = __webpack_public_path__ + "r-v3/img/x.afde74bd.svg";